export const SUPPORTED_AUDIO_EXTENSIONS: string[] = ['mp3', 'ts', 'wav', 'mp4', 'mov'];
